import { lazy } from 'react'

// Route pages load on demand.
const ContractNegotiation = {
    List: lazy(() => import('./List')),
    Detail: lazy(() => import('./Detail')),
}

export default ContractNegotiation
